import React, { useState } from 'react';

const ConfirmationModal = ({ isOpen, message, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[999]">
      <div className="bg-white p-6 rounded-lg w-full max-w-md">
        <h2 className="text-xl font-bold mb-4 text-amber-900">Confirm Action</h2>
        <p className="mb-6">{message}</p>
        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-red-600 text-white rounded cursor-pointer hover:bg-red-700"
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

const MenuItemCard = ({ item, onEdit, onDelete }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  
  const handleDeleteClick = () => {
    setShowConfirmModal(true);
  };
  
  const handleConfirmDelete = () => {
    onDelete(item.id);
    setShowConfirmModal(false);
  };
  
  const handleCancelDelete = () => {
    setShowConfirmModal(false);
  };

  return (
    <>
      <div className="bg-white p-1 sm:p-3 rounded-lg shadow-md flex gap-3">
        {item.image_url && (
          <div className="flex justify-center">
            <img 
              src={item.image_url} 
              alt={item.name} 
              className="max-[400px]:size-20 max-sm:size-24 size-32 object-cover rounded-md"
            />
          </div>
        )}
        <div className="flex justify-between items-start gap-2 flex-1">
          <div className="flex flex-col gap-1">
            <h3 className="font-bold text-lg">{item.name} | {item.name_arabic}</h3>
            <p className="text-gray-600 text-sm text-wrap">{item.description} | {item.description_arabic}</p>
            <p className="text-gold-dark font-bold">${item.price.toFixed(2)}</p>
          </div>
          <div className="flex gap-1 max-lg:flex-col">
            <button
              className="text-gold-dark hover:bg-gold-dark hover:text-white border px-1 sm:px-3 py-1 rounded-md"
              onClick={onEdit}
            >
              Edit
            </button>
            <button
              className="text-red-600 hover:bg-red-600 hover:text-white rounded-md border px-1 sm:px-3 py-1"
              onClick={handleDeleteClick}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
      
      <ConfirmationModal
        isOpen={showConfirmModal}
        message={`Are you sure you want to delete "${item.name}"?`}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />
    </>
  );
};

export default MenuItemCard;